import { createApp } from "vue"
import App from "./App"
import router from "./router"
import store from "./store"
import * as ElementPlusIconsVue from "@element-plus/icons-vue"
import "./assets/scss/base.scss"
import "./assets/scss/common.scss"
import "./assets/scss/element.scss"
import "./assets/scss/menu.scss"
import "./assets/iconFont/iconfont.css"
import "element-plus/es/components/message/style/css"
import "element-plus/es/components/message-box/style/css"
import v3ImgPreview from 'v3-img-preview'
import Cookies from 'js-cookie'
import {ElMessageBox } from 'element-plus'
import {markRaw} from "vue"
import { WarningFilled } from "@element-plus/icons-vue"

// import "default-passive-events"
const app = createApp(App)
app.config.warnHandler = () => null
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

if(!sessionStorage.getItem("oldOrganization")) {
  sessionStorage.setItem("oldOrganization", !Cookies.get('EDU-ORGANIZATION') ? '' : Cookies.get('EDU-ORGANIZATION'))
}
if(!sessionStorage.getItem("oldToken")) {
  sessionStorage.setItem("oldToken", !Cookies.get('Authorization') ? '' : Cookies.get('Authorization'))
}

//同一个浏览器在另一个窗口登录另一个账号，窗口切换时页面刷新，同时账号改为最后一次登录的账号
window.addEventListener("visibilitychange", function () {
  const oldOrgId = sessionStorage.getItem("oldOrganization")
  const oldToken = sessionStorage.getItem("oldToken")
  const orgId = !Cookies.get('EDU-ORGANIZATION') ? '' : Cookies.get('EDU-ORGANIZATION')
  const token = !Cookies.get('Authorization') ? '' : Cookies.get('Authorization')

  if (document.hidden === false && (oldOrgId !== orgId || oldToken !== token)) {
    ElMessageBox.confirm('检测到您切换了账号或者机构，点击刷新页面', '温馨提示', {
      confirmButtonText: '确定',
      showCancelButton: false,
      closeOnClickModal: false,
      showClose: false,
      closeOnPressEscape: false,
      icon: markRaw(WarningFilled),
      customClass: 'confirm-info-icon'
    }).then(async () => {
      sessionStorage.setItem("oldOrganization", orgId)
      sessionStorage.setItem("oldToken", token);
      window.location.href = '#/home'
      window.location.reload()
    })
  }
});
app.use(router).use(store).use(v3ImgPreview).mount("#app")
